let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ch3xJ")).then(() => parcelRequire('wiDoP'));